import { ASSET_ID, FILE_NAME } from '../../../../../../Google/AdForms/fields'
import { STATUS } from '../../../../../fields'
import {
  AD_FILE,
  FILE_TYPE,
  FILE_URL,
  MEDIA_HEIGHT as FILE_HEIGHT,
  MEDIA_TYPE,
  MEDIA_WIDTH as FILE_WIDTH,
  UPLOADED_MEDIA_TYPE
} from '../../../../../../ReusableFormFields/AdFileUpload/fields'
import { CLICK_THROUGH_LINK, CREATIVE_TYPE_VIDEO, formatAdLink, MEDIA_HEIGHT, MEDIA_WIDTH } from '../../../../fields'
import { VIDEO_DEFAULT } from '../../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { MEDIA_ITEMS } from './fields'

export const formatMediaFile = fileMediaValues => {
  return {
    [AD_FILE]: fileMediaValues[AD_FILE],
    [FILE_NAME]: fileMediaValues.file_name,
    [MEDIA_WIDTH]: fileMediaValues[FILE_WIDTH],
    [MEDIA_HEIGHT]: fileMediaValues[FILE_HEIGHT],
    [FILE_TYPE]: fileMediaValues[MEDIA_TYPE],
    [MEDIA_TYPE]: fileMediaValues[UPLOADED_MEDIA_TYPE]
  }
}

export const transformValuesToBE = ({ values, campaignId, lineItemId, lineItemType, account, rightsHolderId }) => {
  // we always keep initial media file in the array to represent file uploading element on the UI
  // this initial media should be removed from the values to be sent to the BE
  const uploadedMedias = values[MEDIA_ITEMS].filter(ad => ad[ASSET_ID])

  return {
    [MEDIA_ITEMS]: uploadedMedias.map(ad => ({
      name: ad[FILE_NAME],
      campaign_id: campaignId,
      line_item_id: lineItemId,
      account: account,
      account_id: rightsHolderId,
      [STATUS]: values[STATUS],
      dimensions: {
        [MEDIA_WIDTH]: ad[MEDIA_WIDTH],
        [MEDIA_HEIGHT]: ad[MEDIA_HEIGHT]
      },
      hosting_source: 'HOSTING_SOURCE_HOSTED',
      assets: [
        {
          asset: {
            media_id: ad[ASSET_ID],
            url: ad[FILE_URL]
          },
          role: 'ASSET_ROLE_MAIN'
        }
      ],
      exit_events: formatAdLink(values[CLICK_THROUGH_LINK]),
      type: lineItemType === VIDEO_DEFAULT ? CREATIVE_TYPE_VIDEO : 'CREATIVE_TYPE_STANDARD'
    }))
  }
}
